module.exports = __webpack_public_path__ + "static/media/oddparents.1f49ec02.gif";